import React, { useEffect } from 'react';
import { Hotkey, KeyboardKey } from './hotkey-context';

// SVG icons for special keys
const KeyIcons = {
  ENTER: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z" />
    </svg>
  ),
  SHIFT: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M8.12 14.71L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71a.9959.9959 0 0 0-1.41 0L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.38 1.03.39 1.42 0z" />
    </svg>
  ),
  TAB: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z" />
    </svg>
  ),
  BACKSPACE: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14zm-11.59-2L14 13.41 17.59 17 19 15.59 15.41 12 19 8.41 17.59 7 14 10.59 10.41 7 9 8.41 12.59 12 9 15.59z" />
    </svg>
  ),
  ARROWLEFT: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
    </svg>
  ),
  ARROWRIGHT: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
    </svg>
  ),
  ARROWUP: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
    </svg>
  ),
  ARROWDOWN: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
    </svg>
  ),
  ESCAPE: (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="12">
        esc
      </text>
    </svg>
  ),
  SPACE: (
    <svg viewBox="0 0 36 24" width="2rem" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="12">
        space
      </text>
    </svg>
  ),
  '1': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        1
      </text>
    </svg>
  ),
  '2': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        2
      </text>
    </svg>
  ),
  '3': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        3
      </text>
    </svg>
  ),
  '4': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        4
      </text>
    </svg>
  ),
  '5': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        5
      </text>
    </svg>
  ),
  '6': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        6
      </text>
    </svg>
  ),
  '7': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        7
      </text>
    </svg>
  ),
  '8': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        8
      </text>
    </svg>
  ),
  '9': (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="16" fontWeight="bold">
        9
      </text>
    </svg>
  ),
};

export type SpecialKey = keyof typeof KeyIcons;

/**
 * Returns an icon component for special keyboard keys
 * @param key The keyboard key to get an icon for
 * @returns React element with the icon, or the key string if no icon is found
 */
export function getKeyIcon(key: string): React.ReactNode {
  const specialKey = key as SpecialKey;
  return KeyIcons[specialKey] || key;
}

/**
 * Checks if a key has a special icon mapping
 * @param key The keyboard key to check
 * @returns boolean indicating if the key has a special icon
 */
export function hasKeyIcon(key: string): boolean {
  return key in KeyIcons;
}

type KeyboardHandlerCompat = (
  e: Pick<KeyboardEvent, 'key' | 'preventDefault' | 'ctrlKey' | 'metaKey' | 'altKey' | 'shiftKey'>
) => void;

export const createKeyHandler = (
  map: Partial<Record<KeyboardKey, KeyboardHandlerCompat>>
): KeyboardHandlerCompat => {
  return (e) => {
    const key = e.key as KeyboardKey;
    if (!(key in map)) return;

    const handler = map[key];
    if (handler == null) return;

    const openDialog = document.querySelector('[data-state="open"][role="dialog"]');
    if (openDialog) return;

    const activeElement = document.activeElement;
    const isInputActive =
      activeElement instanceof HTMLElement &&
      (activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable);

    const hasModifier = e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;

    if (!isInputActive && !hasModifier && key === e.key.toLowerCase()) {
      e.preventDefault();
      handler(e);
    }
  };
};

export const useHotkeys = (map: Partial<Record<KeyboardKey, KeyboardHandlerCompat>>) => {
  useEffect(() => {
    const handleKeyDown = createKeyHandler(map);
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [map]);
};
